import { render } from "./NewConfigurationStepConfirmDetails.vue?vue&type=template&id=16851e44&scoped=true"
import script from "./NewConfigurationStepConfirmDetails.vue?vue&type=script&lang=js"
export * from "./NewConfigurationStepConfirmDetails.vue?vue&type=script&lang=js"

import "./NewConfigurationStepConfirmDetails.vue?vue&type=style&index=0&id=16851e44&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16851e44"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem});
